export const INSERT_SKILL_CATEGORY_MUTATION = `
  mutation InsertSkillCategory($input: SkillCategoryInsertInput!) {
    insertSkillCategory(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_SKILL_CATEGORY_MUTATION = `
  mutation UpdateSkillCategory($filter: String!, $input: SkillCategoryUpdateInput!) {
    updateSkillCategory(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_SKILL_CATEGORY_MUTATION = `
  mutation DeleteSkillCategory($filter: String!, $input: SkillCategoryDeleteInput!) {
    deleteSkillCategory(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;

export const INSERT_SKILL_SUB_CATEGORY_MUTATION = `
  mutation InsertSkillSubCategory($input: SkillSubCategoryInsertInput!) {
    insertSkillSubCategory(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_SKILL_SUB_CATEGORY_MUTATION = `
  mutation UpdateSkillSubCategory($filter: String!, $input: SkillSubCategoryUpdateInput!) {
    updateSkillSubCategory(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_SKILL_SUB_CATEGORY_MUTATION = `
  mutation DeleteSkillSubCategory($filter: String!, $input: SkillSubCategoryDeleteInput!) {
    deleteSkillSubCategory(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;

// Skills are created and edited only; there is no delete yet.
export const INSERT_SKILL_MUTATION = `
  mutation InsertSkill($input: SkillInsertInput!) {
    insertSkill(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_SKILL_MUTATION = `
  mutation UpdateSkill($filter: String!, $input: SkillUpdateInput!) {
    updateSkill(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;
